var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.417C11.3808 10.417 12.5 9.2977 12.5 7.91699C12.5 6.53628 11.3808 5.41699 10 5.41699C8.61933 5.41699 7.50004 6.53628 7.50004 7.91699C7.50004 9.2977 8.61933 10.417 10 10.417Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3337C11.6667 15.0003 16.6667 12.8489 16.6667 8.33366C16.6667 4.65176 13.6819 1.66699 10 1.66699C6.31814 1.66699 3.33337 4.65176 3.33337 8.33366C3.33337 12.8489 8.33337 15.0003 10 18.3337Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.122df82c6f95eb3f07767feea34d8ea5.svg";
export { ForwardRef as ReactComponent };